export const BREAKPOINTS = {
  xs: 320,
  sm: 450,
  md: 650,
  lg: 750,
  xl: 950,
  xxl: 1350,
};
